<template>
  <div id="register_outer" class="container-fluid vue_body_min_height">
    <div>
      <div id="register_top_labels">
        <div :class="['top_label_text', registerStatus == 0 ? 'active' : '']">创建账号</div>
        <div class="top_label_arrow"></div>
        <div :class="['top_label_text', registerStatus == 1 ? 'active' : '']">注册账号</div>
      </div>
      <div id="register_form_outer" v-if="registerStatus == 0">
          <select name="register_type" class="all_div_width" v-model="userType">
            <option value="0">个人用户</option>
            <option value="1">团体用户</option>
          </select>
          <div id="register_type_notice" class="all_div_width">
            <div style="width: 100%;padding-left: 5px;text-align: left;" >个人用户：主体为个人，账户为个人所有；团体用户：主体为机构，账户为机构所有。创建后无法变更。</div>
          </div>
          <div class="register_input_out all_div_width">
            <input class="register_input_text" type="text" :placeholder="userNamePlaceholder" v-model="userName" />
            <div style="margin-top: 5px;color: #ddd;text-align: left;padding-left: 5px;font-size: 12px;">支持中英文字符，限10字符以内。</div>
          </div>

          <div class="register_input_out all_div_width">
            <input class="register_input_text" type="text" v-model="userPhone" placeholder="请输入手机号">
          </div>

          <div class="register_input_out register_phone_number_out all_div_width">
            <input class="register_input_code" type="text" v-model="userVerifyCode" placeholder="请输入验证码" >
            <input v-if="timeValue <= 0" class="register_input_button" type="button" value="获取验证码" @click="codeButonClicked">
            <input v-else type="text" disabled="true" class="register_time_label" :value="timeValue + '秒后重试'" >
          </div>


          <div class="register_input_out all_div_width">
            <input class="register_input_text" type="password" v-model="userPwd" placeholder="请输入密码" />
            <password-verifiy style="margin-top: 5px;" v-bind:password="userPwd" />
          </div>

        <div class="register_input_out all_div_width">
          <input class="register_input_text" type="password" v-model="doubleUserPwd" placeholder="请再次输入密码"  />
        </div>

          <div class="register_input_out all_div_width">
            <div style="margin-bottom: 15px;color: #ddd;text-align: center;padding-left: 5px;font-size: 12px;" >注册即代表您同意 <a href="static/shl_protocol.html"  style="color: #fc1a34;">《上海市篮球协会用户服务协议》</a></div>
            <input class="register_input_submit" type="button" value="提交注册   >" @click="registerButtonClicked" />
          </div>
      </div>
      <div id="register_success_outer" style="width: 100%;" v-else>
        <div class="all_div_width">
          <img class="register_success_img" src="../assets/shl_register_success.png" >
          <div class="register_success_title" >恭喜注册成功</div>
          <div class="register_success_desc" >{{redirectTimeValue}}s后自动跳转登录页</div>
        </div>
        <a href="javascript:void(null);" @click="loginButtonClicked" >立即登录  ></a>
      </div>
    </div>
  </div>
</template>

<script>
import PasswordVerifiy from "../components/PasswordVerifiy";
// import ProtocolHtml from '../../static/上海市篮球协会用户协议.html';
export default {
  name: "RegisterPage",
  components: {
    PasswordVerifiy
  },
  data() {
    return {
      registerStatus: 0,
      userPwd: '',
      userName: '',
      userType: 0,
      userPhone: '',
      doubleUserPwd: '',
      userVerifyCode: '',
      timeValue: 0,
      codeTimerFlag: null,
      redirectTimeValue: 0,
      redirectTimerFlag: null,
      codeSendLoading: 0,
      submitSendLoading: 0,
      protocol: null,
    }
  },
  computed: {
    userNamePlaceholder() {
      return this.userType == 1 ? '请输入团体名称' : '请输入用户名称';
    }
  },

  methods: {
    loginButtonClicked() {
      this.clearCodeTimer();
      this.clearRedirectTimer();
      this.$router.push({name: 'loginPage'});
    },
    registerButtonClicked() {
      let userType = this.userType;
      let username = this.userName.removeBlanks();
      if (username == '') {
        this.$toast('请输入用户名称！');
        return;
      }

      let phone = this.userPhone.removeBlanks();
      // console.log(phone);
      if (phone == '') {
        this.$toast('请输入手机号！');
        return;
      }

      if (!phone.isPhoneNumber()) {
        this.$toast('手机号格式不正确！');
        return;
      }


      let phone_verify = this.userVerifyCode.removeBlanks();
      if (phone_verify == '') {
        this.$toast('请输入验证吗！');
        return;
      }

      let pwd = this.userPwd.removeBlanks();
      let doublePwd = this.doubleUserPwd.removeBlanks();

      if (pwd.length == 0) {
        this.$toast('请输入密码！');
        return;
      }

      if (pwd.length < 6) {
        this.$toast('密码不得少于6位！')
        return;
      }

      if (pwd != doublePwd) {
        this.$toast('两次密码输入不一致！');
        return;
      }

      let params = {
        nickname: username,
        name: username,
        password: pwd,
        isTeam: userType,
        mobile: phone,
        verificationCode: phone_verify,
      }
      // console.log(params);
      var _this = this;
      this.$store.state.http.ajax.userReg(params, function (data) {
        // console.log(data);
        let code = data.code;
        if (code == 0) {
          _this.$toast('注册成功');
          _this.timeValue = 0;
          _this.beginRedirectTimer();
          _this.registerStatus = 1;
          return;
        }

        switch (code) {
          case 1:
            _this.$toast('注册信息不完整！');
            break;
          case 2:
            _this.$toast('验证码有误，请检查！');
            break;
          case 3:
            _this.$toast('手机号已存在！');
            break;
          case 4:
            _this.$toast('用户名已存在！');
            break;
          default:
            _this.$toast('不能识别错误类型: code' + code);
        }

      }, function (data) {
        _this.$toast('注册失败，请重试！');
        // console.log(data);
      });

    },

    codeButonClicked() {
      if (this.codeSendLoading == 1) {
        return;
      }
      if (this.timeValue > 0) {
        return;
      }
      let phone = this.userPhone.removeBlanks();
      if (phone == '') {
        this.$toast('请输入手机号！');
        return;
      }

      if (!phone.isPhoneNumber()) {
        this.$toast('手机号格式不正确！');
        return;
      }

      let _this = this;
      this.codeSendLoading = 1;
      this.$store.state.http.ajax.smsSend({tag: 'reg', phoneNumbers: phone}, function (data) {
        _this.codeSendLoading = 0;
        if (data.code == 0) {
          _this.$toast('发送成功');
          _this.beginTimer();
          return;
        }

        // console.log(data);
        _this.$toast('发送失败！');
      }, function (data) {
        _this.codeSendLoading = 0;
        _this.$toast('发送失败，请重试！')
        // console.log(data);
      })


    },
    beginTimer() {
      if (this.timeValue > 0) {
        return;
      }
      var _this = this;
      this.timeValue = 60;
      this.codeTimerFlag = setInterval(function () {
        _this.timeValue --;
        if (_this.timeValue <= 0) {
          _this.clearCodeTimer();
        }
      }, 1000)
    },

    clearCodeTimer () {
      if (this.codeTimerFlag != null) {
        clearInterval(this.codeTimerFlag);
        this.timeValue = 0;
        this.codeTimerFlag = null;
      }
    },

    clearRedirectTimer() {
      if (this.redirectTimerFlag != null) {
        clearInterval(this.redirectTimerFlag);
        this.redirectTimeValue = 0;
        this.redirectTimerFlag = null;
      }
    },

    beginRedirectTimer() {
      if (this.redirectTimeValue > 0) {
        return;
      }
      this.redirectTimeValue = 10;
      var _this = this;
      this.redirectTimerFlag = setInterval(function () {
        _this.redirectTimeValue --;
        if (_this.redirectTimeValue <= 0) {
          _this.loginButtonClicked();
        }
      }, 1000);
    }
  }

}
</script>

<style scoped>
  #register_outer {
    background-image: url("../assets/shl_login_bg.png");
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-position: center top;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-wrap: nowrap;
    align-items: center;

    padding-top: 50px;
    padding-bottom: 50px;

  }

  .all_div_width {
    width: 90%;
  }

  #register_outer > div {
    border: solid 1px transparent;
    background-color: rgba(255,0,0,0.35);
    border-radius: 10px;
    padding-top: 20px;
    padding-bottom: 30px;
    width: 90vw;
    max-width: 900px;
  }

  @media (min-width: 375px){
    #register_outer {
      min-height: 80vh;
    }
    .all_div_width {
      width: 90vw;
      max-width: 40rem;
    }
    #register_outer > div {
      padding: 30px 5vw;
    }
  }

  @media (min-width: 646px) {
    #register_outer {
      min-height: 75vh;
    }
    .all_div_width {
      width: 40rem;
    }
    #register_outer > div {
      padding: 30px 10vw;
    }
  }

  @media (min-width: 768px){
    #register_outer {
      min-height: 75vh;
    }
  }

  @media (min-width: 992px) {
    #register_outer {
      min-height: 83vh;
    }
  }

  @media (min-width: 1200px) {
    #register_outer {
      min-height: 82vh;
    }
  }

  #register_top_labels {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
    padding-right: 15px;
  }

  #register_top_labels .top_label_arrow {
    background-color: white;
    width: 40%;
    height: 4px;
    border-radius: 2px;
  }

  #register_top_labels .top_label_text {
    font-size: 1.5rem;
    font-weight: bold;
    color: #666;
  }

  #register_top_labels .active {
    color: white;
  }

  #register_form_outer {
    text-align: center;
    margin-top: 20px;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  #register_success_outer {
    text-align: center;
    margin-top: 2vh;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: 35rem;
    color: white;
    width: 100%;
  }

  #register_success_outer .register_success_img {
    height: 44px;
    width: auto;
    margin-top: 8rem;
  }

  #register_success_outer .register_success_title {
    font-size: 3rem;
    margin-top: 4rem;
  }

  #register_success_outer .register_success_desc {
    font-size: 1rem;
    margin-top: 1rem;
  }

  #register_success_outer a {
    margin-top: 6rem;
    color: white;
    text-decoration: none;
    font-size: 1.5rem;
    font-weight:bold;
    background-color: #fc1a34;
    height: 30px;
    border-radius: 15px;
    width: 150px;
    vertical-align: middle;
    line-height: 30px;
  }

  #register_form_outer select {
    background-color: white;
    color: #333;
    text-indent: 15px;
    font-size: 1rem;
    padding-top: 8px;
    padding-bottom: 8px;
    outline: none;
    border-radius: 6px;
    border: solid 1px transparent;
  }

  #register_type_notice {
    color: #ddd;
    display: flex;
    font-size: 0.5rem;
    font-weight: bold;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
    margin-top: 10px;
  }

  #register_form_outer input {
    color: black;
    letter-spacing: 1.5px;
    font-size: 1rem;
    outline: none;
  }

  #register_form_outer .register_input_out {
    margin-top: 20px;
  }

  #register_form_outer input::-webkit-input-placeholder {
    color: #999;
  }

  #register_form_outer .register_input_text {
    width: 100%;
    border-radius: 8px;
    height: 3rem;
    text-indent: 15px;
    border: solid 1px transparent;
  }

  #register_form_outer .register_input_code {
    border-radius: 8px;
    height: 3rem;
    text-indent: 15px;
    border: solid 1px transparent;
    width: 60%;
  }


  #register_form_outer .register_input_button {
    width: 37%;
  }

  @media screen and (min-width: 768px){
    #register_form_outer .register_input_button {
      width: 35%;
    }
  }

  #register_form_outer .register_input_button, #register_form_outer .register_input_submit {
    height: 3rem;
    border-radius: 1.5rem;
    border: solid 1px transparent;
    background-color: #fc1a34;
    color: white;
    font-size: 1.rem;
    padding: 0;
    font-weight: bold;
  }

  #register_form_outer .register_input_submit {
    width: 65%;
    max-width: 200px;
  }


  .register_phone_number_out {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
  }

  #register_form_outer .register_time_label {
    width: 35%;
    border-radius: 20px;
    height: 3rem;
    color: #999;
    background-color: white;
    font-size: 1rem;
    outline: none;
    font-weight: bold;
    text-align: center;
    border: none;
  }

</style>



// WEBPACK FOOTER //
// src/pages/RegisterPage.vue